import TermsAndConditions from '#app/components/termsAndConditions/termsAndConditions.tsx'

export default function termsAndConditionsPage() {
	return <TermsAndConditions />
}
